import { render, staticRenderFns } from "./CertificationManage.vue?vue&type=template&id=e7589294&scoped=true&"
import script from "./CertificationManage.vue?vue&type=script&lang=js&"
export * from "./CertificationManage.vue?vue&type=script&lang=js&"
import style0 from "./CertificationManage.vue?vue&type=style&index=0&id=e7589294&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7589294",
  null
  
)

export default component.exports